export default __webpack_public_path__ + "static/media/django.ffb91ea1.svg";